import React, { memo, HTMLProps } from 'react';
import classnames from 'classnames';
import styles from './image.module.scss';
import Element from '../../element';
interface IProps extends HTMLProps<HTMLImageElement> {
    src: string;
    alt?: string;
    size?: number;
    rounded?: boolean;
    className?: string;
    children?: React.ReactNode;
}

const Image = React.forwardRef(
    (
        {
            src,
            alt = '',
            size = 48,
            rounded,
            className,
            children,
            width,
            height,
            ...rest
        }: IProps,
        ref
    ) => {
        let s = `${size}x${size}`;

        return (
            <Element
                {...rest}
                domRef={ref}
                renderAs="figure"
                className={classnames(styles.image, className, {
                    [`is-${s}`]: s,
                    'is-rounded': rounded,
                })}
            >
                {src && (
                    <img
                        src={src}
                        alt={alt}
                        width={width}
                        height={height}
                    />
                )}
            </Element>
        );
    }
);

export default memo(Image);
